import Collection from 'lib/client/collections/collection'
import _ from 'lodash'

class CovetrusAppointmentStatuses extends Collection {
    fetch(params){
        params = _.pickBy(params, _.identity);
        let query = Object.entries(params).map(([key, value])=>
            `${key}=${value}`
        )
        if(query.length !== 0){
            query = `?${query.join('&')}`
        }else{
            query = ''
        }

        return this.axios.get(`/operations/${this.props.currentOrganization.id}/covetrus-appointment-statuses${query}`)
    }
    create(params){
        return this.axios.post(`/operations/${this.props.currentOrganization.id}/covetrus-appointment-statuses`, params)
    }
    destroy(params){
        return this.axios.delete(`/operations/${this.props.currentOrganization.id}/covetrus-appointment-statuses`, params)
    }
}

export default CovetrusAppointmentStatuses